export default __webpack_public_path__ + "static/media/sole24ore.a00117ed.png";